import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import NotificationBell from "./NotificationBell";
import AppLayout from "./AppLayout";

export default function ProtectedRoute({ children, layout = false }) {
  const { user, loading, authError, retryAuth } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black text-zinc-500 font-mono-ui overline" data-testid="auth-loading">
        LOADING...
      </div>
    );
  }
  if (authError) return <main className="min-h-screen bg-zinc-950 p-8 text-zinc-100">
    <p role="alert">{authError}</p><button type="button" onClick={retryAuth} className="mt-4 underline">Retry sign-in check</button>
  </main>;
  if (!user) return <Navigate to="/login" replace />;
  
  return (
    <>
      {/* Global Admin Header with Notification Bell */}
      <div className="fixed top-0 right-0 z-50 p-4">
        <NotificationBell />
      </div>
      {layout ? <AppLayout title={typeof layout === "string" ? layout : "Workspace"}>{children}</AppLayout> : children}
    </>
  );
}
